import { useQuery } from '@tanstack/react-query'
import { getAuthenticatedUserProfile } from '@/services/api'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card'

function ProfileField({ label, value }: { label: string; value: string }) {
  return (
    <div className="grid gap-1 border-b border-gray-100 py-3 last:border-0 sm:grid-cols-[10rem_1fr]">
      <dt className="text-sm font-medium text-gray-500">{label}</dt>
      <dd className="text-sm text-gray-900">{value || '—'}</dd>
    </div>
  )
}

export function ProfilePage() {
  const { data: profile, isLoading, isError, error } = useQuery({
    queryKey: ['user-profile'],
    queryFn: getAuthenticatedUserProfile,
  })

  const user = profile?.user

  return (
    <main className="container mx-auto py-4">
      <Card>
        <CardHeader>
          <CardTitle>Profile</CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading && (
            <p className="text-sm text-gray-400">Loading profile…</p>
          )}
          {isError && (
            <p className="text-sm text-red-600">
              {error instanceof Error ? error.message : 'Could not load profile.'}
            </p>
          )}
          {user && (
            <dl>
              <ProfileField
                label="Name"
                value={[user.first_name, user.last_name].filter(Boolean).join(' ')}
              />
              <ProfileField label="Email" value={user.email} />
              <ProfileField label="Organization" value={user.organization.name} />
              <ProfileField label="User ID" value={String(user.id)} />
            </dl>
          )}
        </CardContent>
      </Card>
    </main>
  )
}
